class RechageForm extends HTMLElement {
  constructor() {
    super();
    this.mainElement = this;
    this.form = this.querySelector('form');
    const optionSelectors = this.querySelectorAll('[data-purchase_type]');
    optionSelectors.forEach(option => option.addEventListener('change', this._toggleOptions.bind(this)));
    this.knifesSlider();
    this._toggleOptions('load');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    
    this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
    this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));

    if (this.mainElement.querySelector('.ka-info')) {
      const upElements = this.mainElement.querySelectorAll('.ka-info');
      const upMainElements = this.mainElement.querySelector('.accordion-upsell .accordion__block');

      for (const element of upElements) {
        element.addEventListener('mouseover', () => {
            upMainElements.style.overflow = 'visible';
        });

        element.addEventListener('mouseout', () => {
            upMainElements.style.overflow = 'hidden';
        });
      }
    }
    
  }
  _toggleOptions(event){
    try {
      let currentTarget = event.currentTarget;
      this.variantsData=JSON.parse(this.form.querySelector('[data-variantJSON]').innerText);
      let type=this.form.querySelector('[name="radios"]:checked')?.getAttribute('data-purchase_type');
      let variantId=JSON.parse(this.form.querySelector('[name="id"]').value);
      let priceEle=this.form.closest('[data-product-container]')?.querySelector('[data-currentprice]');
      let perKnifeELe=this.form.closest('[data-product-container]')?.querySelector('[data-preKnife]');
      let currentVarinat=this.variantsData.find(item=>item.id == variantId);
      if (this.form.querySelector('[data-purchase_type="subscription"]:checked')) {
        var sellingPlanId=this.form.querySelector('[data-purchase_type="subscription"]:checked').value;
      }
      let perKnifePrice='';
      
      
      if (type == 'onetime') {
        priceEle.innerHTML=Shopify.formatMoney(currentVarinat.price,window.globalVariables.money_format);
        perKnifePrice=currentVarinat.price/currentVarinat.option1;
        perKnifeELe.innerHTML=`${Shopify.formatMoney(perKnifePrice,window.globalVariables.money_format)} / Knife`
        
      }else if(sellingPlanId != ""){
        let sellingPlanPrice=currentVarinat.selling_plan_allocations.find(plan => plan.selling_plan_id == sellingPlanId);
        perKnifePrice=sellingPlanPrice.price/currentVarinat.option1;
        priceEle.innerHTML=Shopify.formatMoney(sellingPlanPrice.price,window.globalVariables.money_format);
        perKnifeELe.innerHTML=`${Shopify.formatMoney(perKnifePrice,window.globalVariables.money_format)} / Knife`
      }
    } catch (error) {
      console.error(`File: recharge-product-form.js, getting error on _toggleOptions: ${error}`);
    }
  }
  
  manageQtyBtn(event) {
    try {
      event.preventDefault();
      let currentTarget = event.currentTarget;
      let action = currentTarget.dataset.for || 'increase';
      let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
      let currentQty = parseInt($qtyInput.value);
      let finalQty = 1;
      let decreaseQtyBtn = currentTarget.closest('[data-qty-container]').querySelector('[data-for="decrease"]');
      
      if(action == 'decrease' && currentQty < 0){
        if(decreaseQtyBtn) decreaseQtyBtn.classList.add('disabled');
        return false;
      }else if(action == 'decrease'){
        finalQty = currentQty - 1;
        finalQty == 0 ? decreaseQtyBtn.classList.add('disabled') : decreaseQtyBtn.classList.remove('disabled');
      }else{
        if(decreaseQtyBtn) decreaseQtyBtn.classList.remove('disabled');
        finalQty = currentQty + 1;
      }
      
      $qtyInput.value = finalQty;
    } catch (error) {
      Rollbar.error(`File: recharge-product-form.js, getting error on manageQtyBtn: ${error}`);
    }
  }
  
  onSubmitHandler(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    evt.stopImmediatePropagation();
    
    let type=this.form.querySelector('[name="radios"]:checked')?.getAttribute('data-purchase_type');
    const addItems = [];
    const submitButton = this.querySelector('[type="submit"]');
    const qtyInput = this.querySelector('[data-qty-input]');
    const pdpContainer = this.closest('.product-details-wrapper');
    let product_id = this.form.querySelector('input[name="id"]').value;
    if (this.form.querySelector('[data-purchase_type="subscription"]:checked')) {
      var sellingPlanId=this.form.querySelector('[data-purchase_type="subscription"]:checked').value;
    }
    
    let getAllInputs = this.form.querySelectorAll('[data-varid]');
    var getAllAddonVarId = [];
    if (typeof(getAllInputs) != 'undefined' && getAllInputs != null){
      getAllInputs.forEach(element => {
        if(Number(element.value) > 0){
          getAllAddonVarId.push({id: element.getAttribute('data-varid'), quantity: element.value, properties: {_addOn: true, _parentProId: product_id}});
        }
      });
    }
    
    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');
    
    // addItems.push(JSON.parse(serializeForm(this.form)));
    let flag='';
    if (type == 'onetime') {
      flag={
        id:product_id,
        quantity:1
      }
    }else if(sellingPlanId != ""){
      flag={
        id:product_id,
        quantity:1,
        selling_plan:sellingPlanId,
        properties: {
          '_subscription': 'subscription_Product'
        }
      }
    }
    addItems.push(flag);
    if(pdpContainer){
      let addOnItemsEle = pdpContainer.querySelectorAll('[data-addon-selection]:checked');
      addOnItemsEle.forEach((addOn)=>{
        if(!addOn.disabled){
          let addOnParent = addOn.closest('addons-form');
          let addOnJSON = {
            id: addOnParent.querySelector('.variant--id').value,
            quantity: addOnParent.querySelector('.product-quantity').value
          }
          addItems.push(addOnJSON);
        }
      });
    }
    
    const body = JSON.stringify({
      items: addItems
    });
    console.log(body);
    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then(() => {
        if(getAllAddonVarId.length > 0){
          var addOnbody = { items: getAllAddonVarId };
          const result = fetch("/cart/add.json", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            },
            body: JSON.stringify(addOnbody)
          }).then(response => {
            //window.location.href=`/cart`;
          });
        }else{
          //window.location.href=`/cart`;
        }
        
        // this.cartElement.getCartData('open_drawer');
        if(qtyInput) qtyInput.value = 1;
      })
      .catch((e) => {
        console.error(e);
        Rollbar.critical(`File: recharge-product-form.js, getting error on onSubmitHandler: ${e}`);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
        let custom_recharge_product_widget_section = document.querySelector(".custom-recharge-product-widget-section #addtocart");
        if(custom_recharge_product_widget_section) {
          gtag('event', 'custom_add_to_cart');
        }
    
      });
  }
  knifesSlider(){
    try {
      this.valuesSliders = this.mainElement.querySelectorAll('.knife_slider');
      if (this.valuesSliders) {
        this.valuesSliders.forEach((valuesSlider) => {
          let valuesForSlider = [4, 5, 7, 10, 14]; // 4 values
          
          let format = {
            to: function(value) {
              return valuesForSlider[Math.round(value)];
            },
            from: function (value) {
              return valuesForSlider.indexOf(Number(value));
            }
          };
          setTimeout(() => {
            noUiSlider.create(valuesSlider, {
              start: 7,
              behaviour: 'smooth-steps-tap',
              range: { min: 0, max: valuesForSlider.length - 1 },
              // steps of 1
              step: 1,
              connect: true,
              tooltips: true,
              format: format,
              pips: { mode: 'steps', format: format },
            });
            
            // The display values can be used to control the slider
            valuesSlider.noUiSlider.set(['7']);
            this.values(valuesSlider);
            
            
            
            valuesSlider.noUiSlider.on('update', (values) => {
              let noUiValues = valuesSlider.querySelectorAll('.noUi-value'),
                knifeSliderValue = this.mainElement.querySelector('.knife-slider__value');
              
              if(knifeSliderValue) {
                knifeSliderValue.innerHTML = values[0];
              }
              this.querySelector(`variant-radios input[data-handle="${values[0]}"]`).click();
              this._toggleOptions('load');
              noUiValues.forEach(noUiValue => {
                noUiValue.classList.remove('active')
                
                if(noUiValue.innerText == values[0]) {
                  noUiValue.classList.add('active')
                }
              })
            });
            document.querySelector('.noUi-handle').setAttribute('aria-label', 'noUi-Slider');
          }, 3000);
          
        });
      }
    } catch (error) {
      Rollbar.error(`File: recharge-product-form.js, getting error on knifesSlider: ${error}`);
    }
  }
  UpdateValuesSlider(valuesSlider,values){
    let noUiValues = valuesSlider.querySelectorAll('.noUi-value'),
      knifeSliderValue = this.mainElement.querySelector('.knife-slider__value');
    
    if(knifeSliderValue) {
      console.log(values);
      knifeSliderValue.innerHTML = values[0];
    }
    
    noUiValues.forEach(noUiValue => {
      noUiValue.classList.remove('active')
      console.log(values);
      if(noUiValue.innerText == values[0]) {
        noUiValue.classList.add('active')
      }
    })
  }
  values(valuesSlider){
    let noUiValues = valuesSlider.querySelectorAll('.noUi-value');
    
    noUiValues.forEach(noUiValue => {
      noUiValue.classList.remove('active')
      
      if(noUiValue.innerText == 7) {
        noUiValue.classList.add('active')
      }
      
      noUiValue.addEventListener('click', () => {
        noUiValues.forEach( (noUiElement) => {
          noUiElement.classList.remove('active')
        });
        
        noUiValue.classList.add('active')
        valuesSlider.noUiSlider.set([`${Number(noUiValue.innerHTML)}`])
      })
    })
  }
}
customElements.define('rechage-form', RechageForm);

class RechageFormV2 extends HTMLElement {
  constructor() {
    super();
    this.mainElement = this;
    this.form = this.querySelector('form');
    this.quantities = this.querySelector('.knife-selection__wrapper').dataset.quantities.split(',');
    this.defaultQuantity = this.querySelector('.knife-selection__wrapper').dataset.defaultQuantity;
    this.variantsData = JSON.parse(this.querySelector('.variants-json').textContent);
    this.selectedVariant = this.variantsData[2];
    this.productId = this.form.querySelector('input[name="id"]').value;
    this.allAddonVariantIds = [];
    
    if(this.classList.contains("custom-ab-test")){
      this.selectedVariant = this.variantsData[0];
    }

    const optionSelectors = this.querySelectorAll('[data-purchase_type]');
    optionSelectors.forEach(option => option.addEventListener('change', this._toggleOptions.bind(this)));

    this._toggleOptions('load');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    
    this.qtyBtn = this.querySelectorAll('.main-product-quantity-wrapper .quantity-wrapper [data-qty-btn]');
    this.addonsQtyBtn = this.querySelectorAll('.addon-wrapper .quantity-wrapper [data-qty-btn]');
    this.addonsAtcBtn = this.querySelectorAll('.addon-wrapper .addon-add button');
    this.quantityBoxes = this.querySelectorAll('.main-product-quantity-boxes .box-item');

    if (this.qtyBtn) {
      this.qtyBtn.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));
    }

    if (this.addonsQtyBtn) {
      this.addonsQtyBtn.forEach(addonQtyBtn => addonQtyBtn.addEventListener('click', this.manageAddonQtyBtn.bind(this)));
    }

    if (this.addonsAtcBtn) {
      this.addonsAtcBtn.forEach(addonAtcBtn => addonAtcBtn.addEventListener('click', this.onAddonAtcButtonClicked.bind(this)));
    }

    if (this.quantityBoxes) {
      this.quantityBoxes.forEach(quantityBox => quantityBox.addEventListener('click', this.onQuantityBoxClicked.bind(this)));
    }
    
  }
  _toggleOptions() {
    try {
      const type = this.obtainPurchaseType();
      this.variantsData = JSON.parse(this.form.querySelector('[data-variantJSON]').innerText);

      if (type == 'onetime') {
        this.querySelector('.subcriptions-dropdown select').style.display= 'none';
        this.querySelector('.current-variant-price-atc').innerHTML = Shopify.formatMoney(this.selectedVariant.price, window.globalVariables.money_format);
      } else {
        this.querySelector('.subcriptions-dropdown select').style.display= 'block';
        this.querySelector('.current-variant-price-atc').innerHTML = Shopify.formatMoney(this.selectedVariant.selling_plan_allocations[0].price, window.globalVariables.money_format);
      }
    } catch (error) {
      console.error(`File: recharge-product-form.js, getting error on _toggleOptions: ${error}`);
    }
    const qtyInput = document.querySelector('.recharge-form-v2:not(.recharge-form-v3) [data-qty-container]').querySelector('[data-qty-input]');
    this.updatePrices(qtyInput.value);
  }
  
  manageQtyBtn(event) {
    try {
      event.preventDefault();
      const currentTarget = event.currentTarget;
      const qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
      const decreaseQtyBtn = currentTarget.closest('[data-qty-container]').querySelector('[data-for="decrease"]');
      const increaseQtyBtn = currentTarget.closest('[data-qty-container]').querySelector('[data-for="increase"]');
      
      const action = currentTarget.dataset.for || 'increase';
      const currentQty = parseInt(qtyInput.value);
      const variantPosition = this.obtainVariantPosition(this.quantities, currentQty);

      decreaseQtyBtn.classList.remove('disabled');
      increaseQtyBtn.classList.remove('disabled');

      let finalInputQty = this.defaultQuantity;

      if (action == 'decrease') {
        finalInputQty = this.quantities[variantPosition - 1];
        if (finalInputQty == 4) {
          decreaseQtyBtn.classList.add('disabled');
        }
      } else {
        finalInputQty = this.quantities[variantPosition + 1];

        if (finalInputQty == 14) {
          increaseQtyBtn.classList.add('disabled');
        }
      }

      qtyInput.value = finalInputQty;

      // Update prices
      this.selectedVariant = this.obtainVariantObject(finalInputQty);
      this.updatePrices(finalInputQty);
    } catch (error) {
      console.error(`File: recharge-product-form.js, getting error on manageQtyBtn: ${error}`);
    }
  }

  manageAddonQtyBtn(e) {
    try {
      e.preventDefault();
      const currentTarget = e.currentTarget;
      const action = currentTarget.dataset.for || 'increase';
      const qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
      const currentQty = parseInt(qtyInput.value);
      const decreaseQtyBtn = currentTarget.closest('[data-qty-container]').querySelector('[data-for="decrease"]');
      const increaseQtyBtn = currentTarget.closest('[data-qty-container]').querySelector('[data-for="increase"]');
  
      let finalQty = currentQty;
  
      if (action === 'decrease' && currentQty > 0) {
        finalQty = currentQty - 1;
      } else if (action === 'increase') {
        finalQty = currentQty + 1;
      }
  
      if (finalQty < 0) finalQty = 0;
  
      qtyInput.value = finalQty;
  
      // Save addons for later
      const variantId = qtyInput.dataset.varid;
      this.updateAddonList(variantId, finalQty);
  
    } catch (error) {
      console.error("manageAddonQtyBtn error:", error);
    }
  }

  updateAddonList(variantId, quantity) {
    this.allAddonVariantIds = this.allAddonVariantIds.filter(addon => addon.id !== variantId);
  
    if (quantity > 0) {
      this.allAddonVariantIds.push({
        id: variantId,
        quantity: quantity,
        properties: { _addOn: true, _parentProId: this.productId }
      });
    }
    
  }
  
  onAddonAtcButtonClicked(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    const currentTarget = e.currentTarget;
    const addonInput = currentTarget.closest('.qty-add').querySelector('.quantity');
    if (addonInput) {
      this.allAddonVariantIds.push({id: addonInput.getAttribute('data-varid'), quantity: addonInput.value, properties: {_addOn: true, _parentProId: this.productId}});
    }

    currentTarget.classList.add('addon-added');
    currentTarget.querySelector('.addon-text').textContent = 'Added';

    addonInput.closest('.input-group').querySelectorAll('[role="button"]').forEach(button => {
      button.style.pointerEvents = 'none';
    });
  }
  

  onQuantityBoxClicked(e) {
    this.quantityBoxes.forEach(qb => qb.classList.remove('active'));

    const boxItem = e.target.closest('.box-item');
    const quantityInput = this.mainElement.querySelector('.main-product-quantity-wrapper .quantity-wrapper .quantity');

    boxItem.classList.add('active');

    if (quantityInput) {
      const boxNumber = boxItem.dataset.boxNumber * 1;
      quantityInput.value = 1;

      this.selectedVariant = this.obtainVariantObject(boxNumber);
      this.productId = this.selectedVariant.id;
      this.updatePrices(boxNumber);
    }
  }

  obtainVariantPosition(values, inputCurrentQty) {
    let currentQtyPos = 0;
    values.forEach(value => {
      if (value == inputCurrentQty) {
        currentQtyPos = values.indexOf(value);
      }
    })
    return currentQtyPos;
  }

  obtainVariantObject(inputQty) {
    let variantObj;
    this.variantsData.forEach(variant => {
      if (variant.public_title == inputQty) {
        variantObj = variant;
      }
    })
    return variantObj;
  }

  obtainPurchaseType() {
    return this.form.querySelector('[name="radios-v2"]:checked').getAttribute('data-purchase_type');
  }

  updatePrices(inputQty) {
    this.querySelector('.current-variant-price').innerHTML = Shopify.formatMoney(this.selectedVariant.price, window.globalVariables.money_format);
    this.querySelector('.current-variant-per-knife').innerHTML = `${Shopify.formatMoney(this.selectedVariant.price / inputQty, window.globalVariables.money_format)} / Knife`;
    this.querySelector('.custom-product-price').innerHTML = Shopify.formatMoney(this.selectedVariant.price, window.globalVariables.money_format);
    this.querySelector('.subscription-price').innerHTML = Shopify.formatMoney(this.selectedVariant.selling_plan_allocations[0].price, window.globalVariables.money_format);
    this.querySelector('.subscription-per-knife-value').innerHTML = Shopify.formatMoney(this.selectedVariant.selling_plan_allocations[0].price / inputQty, window.globalVariables.money_format);

    const type = this.obtainPurchaseType();

    if (type == 'onetime') {
      this.querySelector('.current-variant-price').innerHTML = Shopify.formatMoney(this.selectedVariant.price, window.globalVariables.money_format);
      this.querySelector('.current-variant-per-knife').innerHTML = `${Shopify.formatMoney(this.selectedVariant.price / inputQty, window.globalVariables.money_format)} / Knife`;
      this.querySelector('.current-variant-price-atc').innerHTML = Shopify.formatMoney(this.selectedVariant.price, window.globalVariables.money_format);
    } else {
      this.querySelector('.current-variant-price').innerHTML = Shopify.formatMoney(this.selectedVariant.selling_plan_allocations[0].price, window.globalVariables.money_format);
      this.querySelector('.current-variant-per-knife').innerHTML = `${Shopify.formatMoney(this.selectedVariant.selling_plan_allocations[0].price / inputQty, window.globalVariables.money_format)} / Knife`;
      this.querySelector('.current-variant-price-atc').innerHTML = Shopify.formatMoney(this.selectedVariant.selling_plan_allocations[0].price, window.globalVariables.money_format);
    }

    this.updateVariantIdInput();
  }

  updateVariantIdInput() {
    this.form.querySelector('input[name="id"]').value = this.selectedVariant.id;
  }
  
  onSubmitHandler(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    evt.stopImmediatePropagation();

    //Refresh parent ID before building payload
    this.allAddonVariantIds = this.allAddonVariantIds.map(addon => ({
      ...addon,
      properties: {
        ...addon.properties,
        _parentProId: this.productId
      }
    }));
    
    const addItems = [];
    const type = this.obtainPurchaseType();
    const submitButton = this.querySelector('[type="submit"]');
    const subscriptionDropdown = this.querySelector('.subcriptions-dropdown select');
    const productDetailsWrapper = this.closest('.product-details-wrapper');

    let sellingPlanId;
    let lineItemData;

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    if (type == 'subscription') {
      sellingPlanId = subscriptionDropdown.value;
    }

    if (type == 'onetime') {
      lineItemData = {
        id: this.productId,
        quantity: 1
      }
    } else {
      lineItemData = {
        id: this.productId,
        quantity: 1,
        selling_plan: sellingPlanId,
        properties: {
          '_subscription': 'subscription_Product'
        }
      }
    }

    addItems.push(lineItemData);

    /*
    if (productDetailsWrapper) {
      const addOnItemsElement = productDetailsWrapper.querySelectorAll('[data-addon-selection]:checked');
      addOnItemsElement.forEach((addOn) => {
        if(!addOn.disabled){
          const addOnParent = addOn.closest('addons-form');
          const addOnJSON = {
            id: addOnParent.querySelector('.variant--id').value,
            quantity: addOnParent.querySelector('.product-quantity').value
          }
          addItems.push(addOnJSON);
        }
      });
    }
    */

    const body = JSON.stringify({
      items: addItems
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then(() => {
        if (this.allAddonVariantIds.length > 0) {
          var addOnbody = {items: this.allAddonVariantIds};
          const result = fetch("/cart/add.json", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            },
            body: JSON.stringify(addOnbody)
          }).then(response => {
            //window.location.href=`/cart`;
          });
        } else {
          //window.location.href=`/cart`;
        }
        
        // this.cartElement.getCartData('open_drawer');
      })
      .catch((e) => {
        console.error(e);
        Rollbar.critical(`File: recharge-product-form.js, getting error on onSubmitHandler: ${e}`);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
        let custom_recharge_product_widget_section = document.querySelector(".custom-recharge-product-widget-section #addtocart");
        if(custom_recharge_product_widget_section) {
          gtag('event', 'custom_add_to_cart');
        }
      });
  }
}
customElements.define('recharge-form-v2', RechageFormV2);

class RechageFormV3 extends HTMLElement {
  constructor() {
    super();
    this.mainElement = this;
    this.form = this.querySelector('form');
    this.quantities = this.querySelector('.knife-selection__wrapper').dataset.quantities.split(',');
    this.defaultQuantity = this.querySelector('.knife-selection__wrapper').dataset.defaultQuantity;
    this.variantsData = JSON.parse(this.querySelector('.variants-json').textContent);
    this.selectedVariant = this.variantsData[2];
    this.productId = this.form.querySelector('input[name="id"]').value;
    this.allAddonVariantIds = [];
    
    if(this.classList.contains("custom-ab-test")){
      this.selectedVariant = this.variantsData[0];
    }

    const optionSelectors = this.querySelectorAll('[data-purchase_type]');
    optionSelectors.forEach(option => option.addEventListener('change', this._toggleOptions.bind(this)));

    this._toggleOptions('load');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    
    this.qtyBtn = this.querySelectorAll('.main-product-quantity-wrapper .quantity-wrapper [data-qty-btn]');
    this.addonsQtyBtn = this.querySelectorAll('.addon-wrapper .quantity-wrapper [data-qty-btn]');
    this.addonsAtcBtn = this.querySelectorAll('.addon-wrapper .addon-add button');
    this.quantityBoxes = this.querySelectorAll('.main-product-quantity-boxes .box-item');

    if (this.qtyBtn) {
      this.qtyBtn.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));
    }

    if (this.addonsQtyBtn) {
      this.addonsQtyBtn.forEach(addonQtyBtn => addonQtyBtn.addEventListener('click', this.manageAddonQtyBtn.bind(this)));
    }

    if (this.addonsAtcBtn) {
      this.addonsAtcBtn.forEach(addonAtcBtn => addonAtcBtn.addEventListener('click', this.onAddonAtcButtonClicked.bind(this)));
    }

    if (this.quantityBoxes) {
      this.quantityBoxes.forEach(quantityBox => quantityBox.addEventListener('click', this.onQuantityBoxClicked.bind(this)));
    }
    
  }
  _toggleOptions() {
    try {
      const type = this.obtainPurchaseType();
      this.variantsData = JSON.parse(this.form.querySelector('[data-variantJSON]').innerText);

      if (type == 'onetime') {
        this.querySelector('.subcriptions-dropdown select').style.display= 'none';
        this.querySelector('.current-variant-price-atc').innerHTML = Shopify.formatMoney(this.selectedVariant.price, window.globalVariables.money_format);
      } else {
        this.querySelector('.subcriptions-dropdown select').style.display= 'block';
        this.querySelector('.current-variant-price-atc').innerHTML = Shopify.formatMoney(this.selectedVariant.selling_plan_allocations[0].price, window.globalVariables.money_format);
      }
    } catch (error) {
      console.error(`File: recharge-product-form.js, getting error on _toggleOptions: ${error}`);
    }
    const qtyInput = document.querySelector('.recharge-form-v3 [data-qty-container]').querySelector('[data-qty-input]');
    this.updatePrices(qtyInput.value);
  }
  
  manageQtyBtn(event) {
    try {
      event.preventDefault();
      const currentTarget = event.currentTarget;
      const qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
      const decreaseQtyBtn = currentTarget.closest('[data-qty-container]').querySelector('[data-for="decrease"]');
      const increaseQtyBtn = currentTarget.closest('[data-qty-container]').querySelector('[data-for="increase"]');
      
      const action = currentTarget.dataset.for || 'increase';
      const currentQty = parseInt(qtyInput.value);
      const variantPosition = this.obtainVariantPosition(this.quantities, currentQty);

      decreaseQtyBtn.classList.remove('disabled');
      increaseQtyBtn.classList.remove('disabled');

      let finalInputQty = this.defaultQuantity;

      if (action == 'decrease') {
        finalInputQty = this.quantities[variantPosition - 1];
        if (finalInputQty == 4) {
          decreaseQtyBtn.classList.add('disabled');
        }
      } else {
        finalInputQty = this.quantities[variantPosition + 1];

        if (finalInputQty == 14) {
          increaseQtyBtn.classList.add('disabled');
        }
      }

      qtyInput.value = finalInputQty;

      // Update prices
      this.selectedVariant = this.obtainVariantObject(finalInputQty);
      this.updatePrices(finalInputQty);
    } catch (error) {
      console.error(`File: recharge-product-form.js, getting error on manageQtyBtn: ${error}`);
    }
  }

  manageAddonQtyBtn(e) {
    try {
      e.preventDefault();
      const currentTarget = e.currentTarget;
      const action = currentTarget.dataset.for || 'increase';
      const qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
      const currentQty = parseInt(qtyInput.value);
      const decreaseQtyBtn = currentTarget.closest('[data-qty-container]').querySelector('[data-for="decrease"]');
      const increaseQtyBtn = currentTarget.closest('[data-qty-container]').querySelector('[data-for="increase"]');
  
      let finalQty = currentQty;
  
      if (action === 'decrease' && currentQty > 0) {
        finalQty = currentQty - 1;
      } else if (action === 'increase') {
        finalQty = currentQty + 1;
      }
  
      if (finalQty < 0) finalQty = 0;
  
      qtyInput.value = finalQty;
  
      // Save addons for later
      const variantId = qtyInput.dataset.varid;
      this.updateAddonList(variantId, finalQty);
  
    } catch (error) {
      console.error("manageAddonQtyBtn error:", error);
    }
  }

  updateAddonList(variantId, quantity) {
    this.allAddonVariantIds = this.allAddonVariantIds.filter(addon => addon.id !== variantId);
  
    if (quantity > 0) {
      this.allAddonVariantIds.push({
        id: variantId,
        quantity: quantity,
        properties: { _addOn: true, _parentProId: this.productId }
      });
    }
    
  }
  
  onAddonAtcButtonClicked(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    const currentTarget = e.currentTarget;
    const addonInput = currentTarget.closest('.qty-add').querySelector('.quantity');
    if (addonInput) {
      this.allAddonVariantIds.push({id: addonInput.getAttribute('data-varid'), quantity: addonInput.value, properties: {_addOn: true, _parentProId: this.productId}});
    }

    currentTarget.classList.add('addon-added');
    currentTarget.querySelector('.addon-text').textContent = 'Added';

    addonInput.closest('.input-group').querySelectorAll('[role="button"]').forEach(button => {
      button.style.pointerEvents = 'none';
    });
  }
  

  onQuantityBoxClicked(e) {
    this.quantityBoxes.forEach(qb => qb.classList.remove('active'));

    const boxItem = e.target.closest('.box-item');
    const quantityInput = this.mainElement.querySelector('.main-product-quantity-wrapper .quantity-wrapper .quantity');

    boxItem.classList.add('active');

    if (quantityInput) {
      const boxNumber = boxItem.dataset.boxNumber * 1;
      quantityInput.value = 1;

      this.selectedVariant = this.obtainVariantObject(boxNumber);
      this.productId = this.selectedVariant.id;
      this.updatePrices(boxNumber);
    }
  }

  obtainVariantPosition(values, inputCurrentQty) {
    let currentQtyPos = 0;
    values.forEach(value => {
      if (value == inputCurrentQty) {
        currentQtyPos = values.indexOf(value);
      }
    })
    return currentQtyPos;
  }

  obtainVariantObject(inputQty) {
    let variantObj;
    this.variantsData.forEach(variant => {
      if (variant.public_title == inputQty) {
        variantObj = variant;
      }
    })
    return variantObj;
  }

  obtainPurchaseType() {
    return this.form.querySelector('[name="radios-v3"]:checked').getAttribute('data-purchase_type');
  }

  updatePrices(inputQty) {
    this.querySelector('.current-variant-price').innerHTML = Shopify.formatMoney(this.selectedVariant.price, window.globalVariables.money_format);
    this.querySelector('.current-variant-per-knife').innerHTML = `${Shopify.formatMoney(this.selectedVariant.price / inputQty, window.globalVariables.money_format)} / Knife`;
    this.querySelector('.custom-product-price').innerHTML = Shopify.formatMoney(this.selectedVariant.price, window.globalVariables.money_format);
    this.querySelector('.subscription-price').innerHTML = Shopify.formatMoney(this.selectedVariant.selling_plan_allocations[0].price, window.globalVariables.money_format);
    this.querySelector('.subscription-per-knife-value').innerHTML = Shopify.formatMoney(this.selectedVariant.selling_plan_allocations[0].price / inputQty, window.globalVariables.money_format);

    const type = this.obtainPurchaseType();

    if (type == 'onetime') {
      this.querySelector('.current-variant-price').innerHTML = Shopify.formatMoney(this.selectedVariant.price, window.globalVariables.money_format);
      this.querySelector('.current-variant-per-knife').innerHTML = `${Shopify.formatMoney(this.selectedVariant.price / inputQty, window.globalVariables.money_format)} / Knife`;
      this.querySelector('.current-variant-price-atc').innerHTML = Shopify.formatMoney(this.selectedVariant.price, window.globalVariables.money_format);
    } else {
      this.querySelector('.current-variant-price').innerHTML = Shopify.formatMoney(this.selectedVariant.selling_plan_allocations[0].price, window.globalVariables.money_format);
      this.querySelector('.current-variant-per-knife').innerHTML = `${Shopify.formatMoney(this.selectedVariant.selling_plan_allocations[0].price / inputQty, window.globalVariables.money_format)} / Knife`;
      this.querySelector('.current-variant-price-atc').innerHTML = Shopify.formatMoney(this.selectedVariant.selling_plan_allocations[0].price, window.globalVariables.money_format);
    }

    this.updateVariantIdInput();
  }

  updateVariantIdInput() {
    this.form.querySelector('input[name="id"]').value = this.selectedVariant.id;
  }
  
  onSubmitHandler(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    evt.stopImmediatePropagation();

    //Refresh parent ID before building payload
    this.allAddonVariantIds = this.allAddonVariantIds.map(addon => ({
      ...addon,
      properties: {
        ...addon.properties,
        _parentProId: this.productId
      }
    }));
    
    const addItems = [];
    const type = this.obtainPurchaseType();
    const submitButton = this.querySelector('[type="submit"]');
    const subscriptionDropdown = this.querySelector('.subcriptions-dropdown select');
    const productDetailsWrapper = this.closest('.product-details-wrapper');

    let sellingPlanId;
    let lineItemData;

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    if (type == 'subscription') {
      sellingPlanId = subscriptionDropdown.value;
    }

    if (type == 'onetime') {
      lineItemData = {
        id: this.productId,
        quantity: 1
      }
    } else {
      lineItemData = {
        id: this.productId,
        quantity: 1,
        selling_plan: sellingPlanId,
        properties: {
          '_subscription': 'subscription_Product'
        }
      }
    }

    addItems.push(lineItemData);

    /*
    if (productDetailsWrapper) {
      const addOnItemsElement = productDetailsWrapper.querySelectorAll('[data-addon-selection]:checked');
      addOnItemsElement.forEach((addOn) => {
        if(!addOn.disabled){
          const addOnParent = addOn.closest('addons-form');
          const addOnJSON = {
            id: addOnParent.querySelector('.variant--id').value,
            quantity: addOnParent.querySelector('.product-quantity').value
          }
          addItems.push(addOnJSON);
        }
      });
    }
    */

    const body = JSON.stringify({
      items: addItems
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then(() => {
        if (this.allAddonVariantIds.length > 0) {
          var addOnbody = {items: this.allAddonVariantIds};
          const result = fetch("/cart/add.json", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            },
            body: JSON.stringify(addOnbody)
          }).then(response => {
            //window.location.href=`/cart`;
          });
        } else {
          //window.location.href=`/cart`;
        }
        
        // this.cartElement.getCartData('open_drawer');
      })
      .catch((e) => {
        console.error(e);
        Rollbar.critical(`File: recharge-product-form.js, getting error on onSubmitHandler: ${e}`);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
        let custom_recharge_product_widget_section = document.querySelector(".custom-recharge-product-widget-section #addtocart");
        if(custom_recharge_product_widget_section) {
          gtag('event', 'custom_add_to_cart');
        }
      });
  }
}
customElements.define('recharge-form-v3', RechageFormV3);

/* ---------------------------------------------------------------------------
 * Accessibility: make the "How many knives?" quantity boxes keyboard-operable.
 * The boxes are click-only <div>s; here we expose them as an ARIA radiogroup
 * with roving tabindex + arrow-key navigation, reusing the existing click
 * handlers for the actual quantity/price selection logic.
 * ------------------------------------------------------------------------- */
(function () {
  function upgradeQuantityBoxes(group) {
    if (group.dataset.a11yRadiogroup) return;
    var boxes = Array.prototype.slice.call(group.querySelectorAll('.box-item'));
    if (!boxes.length) return;
    group.dataset.a11yRadiogroup = 'true';
    group.setAttribute('role', 'radiogroup');
    if (!group.getAttribute('aria-label')) group.setAttribute('aria-label', 'How many knives?');

    function sync() {
      var activeIndex = boxes.findIndex(function (b) { return b.classList.contains('active'); });
      if (activeIndex < 0) activeIndex = 0;
      boxes.forEach(function (b, i) {
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', b.classList.contains('active') ? 'true' : 'false');
        b.setAttribute('aria-label', (b.dataset.boxNumber || b.textContent.trim()) + ' knives');
        b.setAttribute('tabindex', i === activeIndex ? '0' : '-1');
      });
    }
    sync();

    boxes.forEach(function (box, i) {
      box.addEventListener('keydown', function (e) {
        var target = null;
        switch (e.key) {
          case 'ArrowRight': case 'ArrowDown': target = boxes[(i + 1) % boxes.length]; break;
          case 'ArrowLeft': case 'ArrowUp': target = boxes[(i - 1 + boxes.length) % boxes.length]; break;
          case 'Home': target = boxes[0]; break;
          case 'End': target = boxes[boxes.length - 1]; break;
          case ' ': case 'Enter': target = box; break;
          default: return;
        }
        e.preventDefault();
        target.click(); // reuse the existing selection logic (quantity, price, .active)
        sync();
        target.focus();
      });
    });

    // Keep ARIA/tabindex in sync when .active changes (mouse clicks, programmatic resets)
    var observer = new MutationObserver(sync);
    boxes.forEach(function (b) { observer.observe(b, { attributes: true, attributeFilter: ['class'] }); });
  }

  function init() {
    document.querySelectorAll('.main-product-quantity-boxes').forEach(upgradeQuantityBoxes);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();